import React, { useState, useEffect, useRef } from 'react';
import Header from '../Common_Files/Header';
import Footer from '../Common_Files/Footer';
import config from '../Common_Files/Config';
import AddBrandModal from '../Master/Add/AddBrandModal';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import axios from 'axios';
import Swal from 'sweetalert2';

const Brand = () => {
    const [searchValue, setSearchValue] = useState([]);
    const editModalRef = useRef(null);    
    const tableRef = useRef(null); // Reference to the table element
    const accessToken = localStorage.getItem('accessToken');

    const initializeDataTable = () => {
      if (!accessToken) {
        window.location.href = '/login';
        return;
    }
      const $table = $(tableRef.current);
      const searchValue = $('#searchValue').val();
      if ($.fn.DataTable.isDataTable($table)) {
          $table.DataTable().destroy();
      }
  
      let i = 0;
      // Initialize DataTable with server-side processing
      $table.DataTable({
          processing: true,
          serverSide: true,
          ajax: {
              url: `${config.api_url}/ws-get-brand-list`,
              type: 'POST',
              data: function (d) {
                  return $.extend({}, d, {
                      draw: d.draw,
                      start: d.start,
                      length: d.length,
                      searchValue : searchValue
                  });
              },
              dataSrc: function (json) {
                  return json.data;
              }
          },
          language: {
              paginate: {
                  first: 'First',
                  last: 'Last',
                  next: 'Next',
                  previous: 'Previous',
              },
              search: 'Search:',
          },
          columns: [
              { data: null,
                width: "7%",
                render:function(data, type, row){
                  return ++i;
                }
               },
              { data: 'name',  },
              { data: 'status', width: "7%" },
              {
                data: null,
                title: 'Action',
                width: "7%",
                render: (data, type, row) => `
                    <a href="#" class="editbtn" title="Edit Brand" data-id="${row.id}" data-bs-toggle="modal" data-bs-target="#edit_brand">
                        <i class="fa fa-edit"></i> 
                    </a>`
              }
          ],
          columnDefs: [
            {
                orderable: false, 
                targets: '_all'
            },
            {
                targets: 2, 
                render: function(data) {
                    return data === '1' ? 'Active' : 'Inactive'; 
                }
            }
        ],
          pageLength: 50,
      });
  

      // Event delegation for edit and view actions
      $table.on('click', '.editbtn', function() {
          const id = $(this).data('id');
          handleEditClick(id);
      });
    };
  
  useEffect(() => {
      initializeDataTable();  
      return () => {
          if (tableRef.current && $.fn.DataTable.isDataTable(tableRef.current)) {
              $(tableRef.current).DataTable().destroy();
          }
      };
  }, [searchValue]);

    const handleSearchBrand = (event) =>
    {
      setSearchValue(event.target.value);
    }

      const handleEditBrand = async (e) => { 
        e.preventDefault();
        try {
          var name = $('#edit_name').val();
          if (name === '') 
          {
            $('#edit_name_error').show();
            return false;
          } else {
            $('#edit_name_error').hide();
          }
          const formElement = document.getElementById("editBrandForm");
          const formData = new FormData(formElement);
          formData.set("status", formData.get("status") === "on" ? 1 : 0);
    
          const response = await axios.post(
            `${config.api_url}/ws-update-brand`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );

          if (response.data.success) {

            if (editModalRef.current) {
              const bsModal = window.bootstrap.Modal.getInstance(editModalRef.current);
              if (bsModal) bsModal.hide();
            }

            Swal.fire({
              title: "Success!",
              text: "Brand updated successfully.",
              icon: "success",
              timer: 1500, 
              showConfirmButton: false,
            })
              .then(() => {
                initializeDataTable();
                document.getElementById("editBrandForm").reset();
              })
              .catch((error) => {
                console.error("Error refreshing brand:", error);
              });
          } else {
            Swal.fire({
              title: "Error!",
              text: "An error occurred while updating a brand.",
              icon: "error",
              timer: 1500, // Automatically close after 1500ms
              showConfirmButton: false,
            });
          }
        } catch (error) {
          console.error("Request Error:", error);
          Swal.fire({
            title: "Error!",
            text: "An error occurred while updating a brand.",
            icon: "error",
            timer: 1500, // Automatically close after 1500ms
            showConfirmButton: false,
          });
        }
      };

      const handleEditClick = async (id) => {
            document.getElementById("editBrandForm").reset();
            $('#edit_name_error').hide();
            const  formData = new FormData();
            formData.set('brand_id', id);
              const response = await axios.post(`${config.api_url}/ws-get-brand-by-id`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                    }
              });            

              if (response.data.brands[0]) 
                {
                $('#edit_name').val(response.data.brands[0].name);
                $('#brand_id').val(response.data.brands[0].id);
                (response.data.brands[0].status == "1") ? $('#status').prop('checked', true) : $('#status').prop('checked', false);
              }
        };

    return (
        <div>
            <Header />
            <AddBrandModal initializeDataTable={initializeDataTable} />
            <div className="breadcrumbs">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <a href="#"><i className="fa fa-home"></i></a> &gt; <a href="dashboard.html">Dashboard</a> &gt; <span className="last-crumb">Brand</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="main-container">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className='add-categy-tbl'>
                            <div class="topsearch-area">
                                <div class="row">
                              <div class="col-12 col-lg-4 col-sm-4">
                                <div class="row">
                                  <label for="inputText" class="col-sm-2 col-form-label">Brand:</label>
                                  <div class="col-sm-6">
                                  <input type="text" className="search-area form-control" autoComplete='off' name="searchValue" id="searchValue" onChange={handleSearchBrand} placeholder="Search Brand" />
                                  </div>
                                </div>
                              </div>
                              <div class="col-12 col-lg-8 col-sm-8">
                                <div style={{ float: "right" }}>
                                <a href="#" className="create-catalogue-btn" data-bs-toggle="modal" data-bs-target="#add_brand">Add New Brand</a>
                                </div>
                              </div>
                            </div> 
                          </div>

                                <div style={{ width: '100%', float: 'left' }}>
                                    <div className="verical-scrl-wrapper" id="style-3">
                                        <table className="table table-bordered dataTable" ref={tableRef}>
                                            <thead>
                                                <tr>
                                                    <th>Sr. No.</th>
                                                    <th>Name</th>
                                                    <th>Status</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Brand Modal */}
            {/*  */}
            <div className="modal fade" id="edit_brand" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" ref={editModalRef}>
              <div className="modal-dialog modal-md">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Edit Brand</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div className="modal-body">
                    <div className="warehousemaster-area">
                      <form id="editBrandForm">
                        <div className="row mb-3 padd-l-13px">
                          <label for="desc" className="col-sm-6 col-form-label">
                            Brand Name <span className="red">*</span>
                          </label>
                          <div className="col-sm-6">
                            <input type="hidden" name="brand_id" id="brand_id" />
                            <input type="text" className="form-control validationCheck" name="name" id="edit_name" />
                            <span id="edit_name_error" style={{ color: 'red', display: 'none' }}> Please enter name </span>
                          </div>
                        </div>
                        <div className="row mb-3 padd-l-13px">
                          <label for="displayName" className="col-sm-6 col-form-label">Status</label>
                          <div className="col-sm-6">
                            <label className="switch">
                              <input className="switch-input" type="checkbox" name="status" id="status" />
                              <span className="switch-label" data-on="Active" data-off="Inactive" ></span>{" "}
                              <span className="switch-handle"></span>
                            </label>
                          </div>
                        </div>
                        <hr />
                        <div className="row padd-l-13px">
                          <div className="col-sm-12">
                            <button type="submit" id="submit" onClick={handleEditBrand} className="popup-innerbtn-common right">Update</button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Footer />
        </div>
    );
};

export default Brand;
